import { Box, chakra, Text } from '@chakra-ui/react';
import { IoAlertCircle, IoChevronForward } from 'react-icons/io5';
import { useSelector } from 'react-redux';

import { dashboardTokens } from '../dashboardTokens';

/**
 * (3153/2635) One warning in the account summary's list: coloured by
 * severity, subject over detail. Warnings that lead somewhere are buttons;
 * the rest only inform.
 */
const NotificationItem = ({ notification, onSelect }) => {
    const { darkMode } = useSelector((state) => state.settings);
    const tokens = dashboardTokens(darkMode);
    const { accent, bg } = tokens.severity[notification.severity];
    const subject =
        notification.count > 1
            ? `${notification.label} (${notification.count})`
            : notification.label;
    const isActionable = !!notification.destination;
    const Row = isActionable ? chakra.button : chakra.div;

    return (
        <chakra.li listStyleType="none">
            <Row
                {...(isActionable && {
                    type: 'button',
                    onClick: () => onSelect(notification),
                    _hover: { boxShadow: 'md' },
                    _focusVisible: { boxShadow: 'outline' },
                })}
                display="flex"
                alignItems="flex-start"
                gap={2.5}
                w="full"
                px={3}
                py={2}
                textAlign="left"
                borderRadius="md"
                borderLeftWidth="3px"
                borderColor={accent}
                bg={bg}
                transition="box-shadow 0.2s">
                <chakra.span
                    color={accent}
                    flexShrink={0}
                    display="inline-flex"
                    mt="2px">
                    <IoAlertCircle size={16} aria-hidden />
                </chakra.span>
                <Box flex="1" minW={0}>
                    <Text
                        fontSize="sm"
                        fontWeight="bold"
                        color={tokens.heading}>
                        {subject}
                    </Text>
                    <Text fontSize="xs" color={tokens.muted}>
                        {notification.detail}
                    </Text>
                </Box>
                {isActionable && (
                    <chakra.span
                        color={tokens.muted}
                        flexShrink={0}
                        display="inline-flex"
                        alignSelf="center">
                        <IoChevronForward size={14} aria-hidden />
                    </chakra.span>
                )}
            </Row>
        </chakra.li>
    );
};

export default NotificationItem;
